import React, {useEffect, useState} from 'react'
import './Department.css';
import Service from "../../../API/Service";
import Table from "../Table/Table";


const Departments = () => {
    const [securityData, setSecurityData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [searchText, setSearchText] = useState('');
    const entity = 'departments'
    const text = 'Are you sure you want to delete this item? This action cannot be undone.'

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getTables(entity, searchText);
                const content = response.data.content;
                setSecurityData(content);

                if (content.length > 0) {
                    setColumns(Object.keys(content[0]));
                }
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
                setSecurityData([]);
            }
        };
        fetchData();
    }, [searchText]);


  return (
    <div className='departments-wrap'>
        <h1>Departments</h1>
        <Table
            entity={entity}
            info={securityData}
            columns={columns}
            text={text}
            setSearchText={setSearchText}
        />
    </div>
  )
}

export default Departments